import React from 'react';
import { Box, Container, Typography, Link, Paper, useTheme, useMediaQuery } from '@mui/material';
import TelegramIcon from '@mui/icons-material/Telegram';
import { motion } from 'framer-motion';

const TelegramBotBanner = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box 
      component="section" 
      sx={{ 
        py: 2, 
        backgroundColor: '#0088cc', // Цвет Telegram
        color: 'white',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            flexDirection: isMobile ? 'column' : 'row',
            textAlign: isMobile ? 'center' : 'left',
            gap: 2
          }}>
            <TelegramIcon sx={{ fontSize: 40 }} />
            <Box>
              <Typography variant="h6" component="span" sx={{ fontWeight: 'bold', mr: 1 }}>
                Полезные советы в Telegram:
              </Typography>
              <Typography variant="body1" component="span">
                Подписывайтесь на нашего бота{' '}
                <Link 
                  href="https://t.me/DomikTyumenBot" 
                  target="_blank" 
                  rel="noopener"
                  sx={{ 
                    color: 'white', 
                    fontWeight: 'bold',
                    textDecoration: 'underline',
                    '&:hover': {
                      color: theme.palette.grey[200]
                    }
                  }}
                >
                  @DomikTyumenBot
                </Link>
              </Typography>
            </Box>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default TelegramBotBanner;
